import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider } from "antd";
import jaJP from "antd/locale/ja_JP";
import enUS from "antd/locale/en_US";
import zhCN from "antd/locale/zh_CN";
import { useTranslation } from "react-i18next";

import AppHeader from "./common/Header";
import AppContent from "./common/Content";
import AppFooter from "./common/Footer";
import ScrollToTop from "./common/ScrollToTop";
import GoogleAnalyticsTracker from "./common/GoogleAnalyticsTracker";
import { getRouterBasename } from "./config";

const getAntdLocale = (langCode: string) => {
  const code = (langCode || "ja").split("-")[0];
  switch (code) {
    case "en":
      return enUS;
    case "zh":
      return zhCN;
    case "ja":
    default:
      return jaJP;
  }
};

const App: React.FC = () => {
  const { i18n } = useTranslation();
  const locale = getAntdLocale(i18n.language);

  return (
    <ConfigProvider locale={locale}>
      <Router basename={getRouterBasename()}>
        <ScrollToTop />
        <GoogleAnalyticsTracker />
        <MainLayout />
      </Router>
    </ConfigProvider>
  );
};

const MainLayout: React.FC = () => {
  return (
    <>
      <AppHeader />
      <AppContent />
      <AppFooter />
    </>
  );
};

export default App;
